import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      t="1641362463536"
      viewBox="0 0 20 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="1212"
      width={width}
      height={height}
    >
      <path
        d="M4.018 4.018H1.742a.57.57 0 0 0-.569.569v9.67c0 .315.255.57.57.57h2.275a.569.569 0 0 0 .569-.57v-9.67a.57.57 0 0 0-.57-.57Zm5.12 3.413H6.862A.57.57 0 0 0 6.293 8v6.258c0 .314.255.569.57.569h2.275a.568.568 0 0 0 .569-.57V8a.569.569 0 0 0-.57-.569Zm5.12-6.258h-2.276a.569.569 0 0 0-.569.57v12.515c0 .314.255.569.57.569h2.275a.568.568 0 0 0 .569-.57V1.743a.569.569 0 0 0-.57-.569Z"
        fill={color}
        fillRule="nonzero"
      />
    </svg>
  )
}

const RankIcon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} />
    </ActionIcon>
  )
}

export default RankIcon
